import { createTheme } from '@mui/material/styles';
import { colors } from 'app/theme/config';

export const highContrastAccessiblePalette = createTheme({
  palette: {
    background: {
      default: colors.black,
    },

    primary: {
      main: colors.white,
    },
    secondary: {
      main: colors.white,
    },
    text: {
      primary: colors.white,
    },
  },
}).palette;
